export default __webpack_public_path__ + "static/media/line-v-08.c56d0c1a.png";